import React, { useState } from "react";
import "./pricerequestform.css";
import { useMutation } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";

const PriceRequestForm = () => {
  const [priceRequestData, setPriceRequestData] = useState({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    estimated_budget: "",
    enquiry_message: "",

    nameStatus: "unchecked",
    emailStatus: "unchecked",
    phoneStatus: "unchecked",
    enquiry_messageStatus: "unchecked",
  });
  const checkSubmit = () => {
    let status = true;

    if (
      priceRequestData.nameStatus == "success" &&
      priceRequestData.phoneStatus == "success" &&
      priceRequestData.emailStatus == "success" &&
      priceRequestData.enquiry_messageStatus == "success"
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const handleChange = (e) => {
    const newData = { ...priceRequestData };
    if (e?.target?.name == "name") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{2,1000}$");
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "phone") {
      const allAlphabeticOnlyRegex = new RegExp("^[0-9]{10}$");
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "email") {
      const allAlphabeticOnlyRegex = new RegExp(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
      );
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "enquiry_message") {
      const allAlphabeticOnlyRegex = new RegExp("^.{5,1000}$", "s");
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newData[e.target.name] = e.target.value;
    setPriceRequestData(newData);
  };
  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}lead`, values);
    },
    onSuccess: (response) => {
      Swal.fire({
        title: 'Your Message Sent successfully',
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", 
        },
      }).then(() => {
        setPriceRequestData({
          name: "",
          email: "",
          phone: "",
          company_name: "",
          estimated_budget: "",
          enquiry_message: "",
        });
      });
    },
    onError:(response)=>{
      Swal.fire({
        title: response?.data?.message,
        icon: "error",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      })
    }
  });
  const handleAdd = (e) => {
    e.preventDefault();
    const values = {
      name: priceRequestData.name,
      email: priceRequestData.email,
      phone: priceRequestData.phone,
      enquiry_message: priceRequestData.enquiry_message,
    };

    mutation.mutate(values);
  };
console.log(priceRequestData);

  return (
    <div className="pricerequest-container  ">
      <h2>Keep In Touch</h2>
      {mutation.isLoading && <TraingleLoading />}

      <form>
        <div className="grid col-span-12 my-4">
          <label className="pricerequest-label">
            Name <span>*</span>
          </label>
          <input
            name="name"
            value={priceRequestData.name}
            onChange={(e) => handleChange(e)}
            className={`pricerequest-input 
              ${
              priceRequestData.nameStatus == "success"
                ? "price-reques-success"
                : priceRequestData?.nameStatus == "error"
                ? "price-reques-error"
                : ""
            }`}
          />
            {priceRequestData?.nameStatus == "error" && (
                <p className="text-sm font-semibold  px-2 text-speed-red">
                  First Name should allow only alphabets.
                </p>
              )}
        </div>
        <div className="grid lg:grid-cols-1 my-4 gap-4">
          <div>
            <label className="pricerequest-label">
              Email <span>*</span>
            </label>
            <input
              name="email"
              value={priceRequestData.email}
              onChange={(e) => handleChange(e)}
              className={`pricerequest-input  
                  ${
              priceRequestData.emailStatus == "success"
                ? "price-reques-success"
                : priceRequestData?.emailStatus == "error"
                ? "price-reques-error"
                : ""
            }`}
            />
               {priceRequestData?.emailStatus == "error" && (
                <p className="text-sm font-semibold  px-2 text-speed-red">
                  Invalid Email
                </p>
              )}
          </div>
          <div>
            <label className="pricerequest-label">
              Phone Number <span>*</span>
            </label>
            <input
              name="phone"
              value={priceRequestData.phone}
              onChange={(e) => handleChange(e)}
              className={`pricerequest-input ${
                priceRequestData.phoneStatus == "success"
                  ? "price-reques-success"
                  : priceRequestData?.phoneStatus == "error"
                  ? "price-reques-error"
                  : ""
              }`}
            />
               {priceRequestData?.phoneStatus == "error" && (
                <p className="text-sm font-semibold  px-2 text-speed-red">
                  Invalid Phone Number
                </p>
              )}
          </div>
        </div>

        <div className="grid col-span-12 my-4">
          <label className="pricerequest-label">
            Message <span>*</span>
          </label>
          <textarea
            name="enquiry_message"
            value={priceRequestData.enquiry_message}
            onChange={(e) => handleChange(e)}
            className={`pricerequest-textarea ${
              priceRequestData.enquiry_messageStatus == "success"
                ? "price-reques-success"
                : priceRequestData?.enquiry_messageStatus == "error"
                ? "price-reques-error"
                : ""
            }`}
          />
           {priceRequestData?.enquiry_messageStatus == "error" && (
                <p className="text-sm font-semibold  px-2 text-speed-red">
                  Message minimum 5 letters
                </p>
              )}
        </div>
        <div className="pricerequest-Submitbox">
          <button
            disabled={checkSubmit()}
            className={`   ${
              checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={(e) => handleAdd(e)}
          >
            Send Message
          </button>
        </div>
      </form>
    </div>
  );
};

export default PriceRequestForm;
